import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'upmarket-my_teams_link_account_settings-click';
/**
 * Event to track the &quot;My team&quot; link in the account settings dropdown, as well as the account settings menus. Only parameter is the type of user who clicked it (OWNER, ADMIN, or CONTRIBUTOR).
 */
export function trackUpmarketMyTeamsLinkAccountSettingsClick(account_type_of_clicker_OWNER_ADMIN_or_CONTRIBUTOR_Custom) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { account_type_of_clicker_OWNER_ADMIN_or_CONTRIBUTOR_Custom },
    });
}
